import { IPaymentMethod } from "@features/Payment/interface/IPaymentMethod";
import { EPAYMENT_TYPES } from "@constants";
import { EPaymentCardType, ISimplePaymentMethodCard } from "@common/SimplePaymentMethodCardList";

export const getSimplePaymentMethodCardList = (paymentMethodList: IPaymentMethod[]): ISimplePaymentMethodCard[] =>
    paymentMethodList
        .filter((paymentMethod) => paymentMethod.paymentMethodType === EPAYMENT_TYPES.CREDIT_CARD)
        .map((paymentMethod) => ({
            providerReference: paymentMethod.providerReference,
            partialDigits: paymentMethod.partialDigits,
            cardholderName: paymentMethod.cardholderName,
            expirationDate: paymentMethod.expirationDate,
            creditCardType: paymentMethod.type as EPaymentCardType,
        }));
